import { useSyncExternalStore } from 'react'
import { doc, onSnapshot, type Unsubscribe } from 'firebase/firestore'
import { firestoreDb } from './firebase'
import {
  normalizePlanLimitOverrides,
  type PlanLimitOverrides,
  getPlanLimitOverrides,
  setPlanLimitOverridesForApp,
  subscribePlanLimitsStore,
  clearPlanLimitsStoreForTests,
} from '../config/planLimitsCore'

export {
  getPlanLimitOverrides,
  setPlanLimitOverridesForApp,
  subscribePlanLimitsStore,
  clearPlanLimitsStoreForTests,
}

export function usePlanLimitOverrides(): PlanLimitOverrides {
  return useSyncExternalStore(subscribePlanLimitsStore, getPlanLimitOverrides, getPlanLimitOverrides)
}

export const subscribePlanLimits = (
  next: (overrides: PlanLimitOverrides) => void,
  fail?: (error: Error) => void,
): Unsubscribe => {
  return onSnapshot(
    doc(firestoreDb, 'owner_config', 'plan_limits'),
    (snapshot) => {
      next(normalizePlanLimitOverrides(snapshot.data()))
    },
    fail,
  )
}
